"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventType = void 0;
var EventType;
(function (EventType) {
  EventType["Purchase"] = "purchase";
  EventType["AddPaymentInfo"] = "add_payment_info";
  EventType["GenerateLead"] = "generate_lead";
  EventType["BeginCheckout"] = "begin_checkout";
  EventType["StartQuiz"] = "start_quiz";
  EventType["QuizQuestionAnswered"] = "quiz_question_answered";
  EventType["AddShippingInfo"] = "add_shipping_info";
})(EventType = exports.EventType || (exports.EventType = {}));